import { Button } from "@chakra-ui/react"
import { FaAngleDoubleRight } from "react-icons/fa"
import usePageStyling from "src/hooks/usePageStyling"

function Submit() {
  return <></>
}

Submit.Default = ({
  title,
  isSubmitting
}: {
  title: string
  isSubmitting: boolean
}) => {
  const roomStyles = usePageStyling("authPageStyling")

  return (
    <Button
      type="submit"
      disabled={isSubmitting}
      width={"100%"}
      my="4"
      mx="auto"
      bg={
        roomStyles?.authPageButtonBackgroundColor
          ? roomStyles?.authPageButtonBackgroundColor
          : "#1AC541"
      }
      border={
        roomStyles?.authPageButtonBorderColor
          ? `1px solid ${
              roomStyles?.authPageButtonBorderColor
                ? roomStyles.authPageButtonBorderColor
                : "transparent"
            }`
          : "0px"
      }
      textColor={
        roomStyles?.authPageButtonTextColor
          ? roomStyles?.authPageButtonTextColor
          : "#FFFFFF"
      }
      _hover={{
        backgroundColor: roomStyles?.authPageButtonMouseoverBackgroundColor
          ? roomStyles.authPageButtonMouseoverBackgroundColor
          : "#24A840",
        textColor: roomStyles?.authPageButtonMouseoverTextColor
          ? roomStyles.authPageButtonMouseoverTextColor
          : "#FFFFFF",
        borderColor: roomStyles?.authPageButtonBorderMouseoverColor ?? null
      }}
      borderRadius={roomStyles?.authPageButtonBorderRadius}
      // onClick={handleOnClick}
      _focus={{}}
      _active={{}}
    >
      {title}
    </Button>
  )
}

Submit.Learnmachine = ({
  isSubmitting,
  title
}: {
  isSubmitting: boolean
  title: string
}) => {
  return (
    <Button
      type="submit"
      disabled={isSubmitting}
      width="fit-content"
      margin="0 auto"
      my="4"
      bg="rgba(0, 0, 0, 0.25)"
      border="1px solid white"
      textColor="white"
      transition=".3s ease"
      _hover={{
        color: "orange"
      }}
      height="46px"
      borderRadius="23px"
      display="flex"
      alignItems="center"
      gap=".35em"
      lineHeight="1rem"
      _focus={{}}
      _active={{}}
    >
      {title} <FaAngleDoubleRight style={{ marginTop: "1px" }} />
    </Button>
  )
}

export default Submit